import { UserUpdate } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import {
  useInvalidateTenantUserListQuery,
  useUpdateTenantUsersQuery,
} from "@/queries/query-tenant-user";

export const useUpdateUsers = (userIds: string[]) => {
  const updateTenantUsersQuery = useUpdateTenantUsersQuery();
  const invalidateTenantUserListQuery = useInvalidateTenantUserListQuery();

  return useMutationWithErrorHandler(async (updates: UserUpdate) => {
    if (userIds === null) return null;
    const promises = userIds.map(async (id) => {
      const update = await getRanaApiV1().UsersApi.userUpdate({ id, userUpdate: updates });
      if (update) updateTenantUsersQuery(id, update);
    });

    await Promise.all(promises);

    // Also invalidate because updating a user can change its position in the list
    // (e.g. when activating/deactivating), which cannot be handled by the item updater
    invalidateTenantUserListQuery();
  });
};
